import AddUserForm from 'components/Configuration/AddUserForm'

export const AddUser = () => {
    return (
            <AddUserForm/>
    )
}

export default AddUser
